import {
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpErrorResponse,
  HttpInterceptor,
  HttpResponse
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, finalize, tap } from "rxjs/operators";
import { ErrorDialogService } from "../../shared/services/error-dialog.service";
import { LoadingDialogService } from "../../shared/services/loading-dialog.service";
import { Injectable } from "@angular/core";
import {NGXLogger} from "ngx-logger";

const AUDIT_LOG_URL = "/audit/log";
@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private errorDialogService: ErrorDialogService,
    private loadingDialogService: LoadingDialogService,
    private logger: NGXLogger
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!request.url.includes(AUDIT_LOG_URL)) {
      //this.loadingDialogService.openDialog();
    }
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        //this.loadingDialogService.hideDialog();
        this.logger.error("Error from error interceptor", error);
        this.errorDialogService.openDialog(error.message ?? JSON.stringify(error), error.status);
        return throwError(error);
      }),
      finalize(() => {
        if (!request.url.includes(AUDIT_LOG_URL)) {
          //this.loadingDialogService.hideDialog();
        }
      })
    ) as Observable<HttpEvent<any>>;
  }
}
